import {
    GET_PROPERTY_TYPE_BREAKDOWN,
    GET_PROPERTY_TYPE_BREAKDOWN_SUCCESS,
    GET_PROPERTY_TYPE_BREAKDOWN_FAILURE,
    GET_SECURITIES_STATUS_BREAKDOWN,
    GET_SECURITIES_STATUS_BREAKDOWN_SUCCESS,
    GET_SECURITIES_STATUS_BREAKDOWN_FAILURE,
    GET_LOAN_STATUS_BREAKDOWN,
    GET_LOAN_STATUS_BREAKDOWN_SUCCESS,
    GET_LOAN_STATUS_BREAKDOWN_FAILURE,
    GET_CLOSING_DATE_BREAKDOWN,
    GET_CLOSING_DATE_BREAKDOWN_SUCCESS,
    GET_CLOSING_DATE_BREAKDOWN_FAILURE,
    GET_LOANS_SUMMARY,
    GET_LOANS_SUMMARY_SUCCESS,
    GET_LOANS_SUMMARY_FAILURE,
    GET_CASHFLOW_PER_MONTH_BREAKDOWN,
    GET_CASHFLOW_PER_MONTH_BREAKDOWN_SUCCESS,
    GET_CASHFLOW_PER_MONTH_BREAKDOWN_FAILURE,
    GET_DASHBOARD_SUMMARY_TOTALS,
    GET_DASHBOARD_SUMMARY_TOTALS_SUCCESS,
    GET_DASHBOARD_SUMMARY_TOTALS_FAILURE,
} from './constants';

const initialState = {
    propertyTypeBreakdown:      { data: [], loading: false, loaded: false, error: null },
    securitiesStatusBreakdown:  { data: [], loading: false, loaded: false, error: null },
    loanStatusBreakdown:        { data: [], loading: false, loaded: false, error: null },
    closingDateBreakdown:       { data: [], loading: false, loaded: false, error: null },
    loansSummary:               { data: [], loading: false, loaded: false, error: null },
    cashflowPerMonthBreakdown:  { data: [], loading: false, loaded: false, error: null },
    dashboardSummaryTotals:     { data: [], loading: false, loaded: false, error: null },
};

const reports = (state = initialState, action) => {
    switch (action.type) {
        /* — GET PROPERTY TYPE BREAKDOWN — */
        case GET_PROPERTY_TYPE_BREAKDOWN:
            return {
                ...state,
                propertyTypeBreakdown: { ...state.propertyTypeBreakdown, loading: true, error: null },
            };
        case GET_PROPERTY_TYPE_BREAKDOWN_SUCCESS:
            return {
                ...state,
                propertyTypeBreakdown: { data: action.payload, loading: false, loaded: true, error: null },
            };
        case GET_PROPERTY_TYPE_BREAKDOWN_FAILURE:
            return {
                ...state,
                propertyTypeBreakdown: { ...state.propertyTypeBreakdown, loading: false, loaded: false, error: action.payload },
            };
        case GET_SECURITIES_STATUS_BREAKDOWN:
            return {
                ...state,
                securitiesStatusBreakdown: { ...state.securitiesStatusBreakdown, loading: true, error: null },
            };
        case GET_SECURITIES_STATUS_BREAKDOWN_SUCCESS:
            return {
                ...state,
                securitiesStatusBreakdown: { data: action.payload, loading: false, loaded: true, error: null },
            };
        case GET_SECURITIES_STATUS_BREAKDOWN_FAILURE:
            return {
                ...state,
                securitiesStatusBreakdown: { ...state.securitiesStatusBreakdown, loading: false, loaded: false, error: action.payload },
            };

        case GET_LOAN_STATUS_BREAKDOWN:
            return {
                ...state,
                loanStatusBreakdown: { ...state.loanStatusBreakdown, loading: true, error: null },
            };
        case GET_LOAN_STATUS_BREAKDOWN_SUCCESS:
            return {
                ...state,
                loanStatusBreakdown: { data: action.payload, loading: false, loaded: true, error: null },
            };
        case GET_LOAN_STATUS_BREAKDOWN_FAILURE:
            return {
                ...state,
                loanStatusBreakdown: { ...state.loanStatusBreakdown, loading: false, loaded: false, error: action.payload },
            };

        case GET_CLOSING_DATE_BREAKDOWN:
            return {
                ...state,
                closingDateBreakdown: { ...state.closingDateBreakdown, loading: true, error: null },
            };
        case GET_CLOSING_DATE_BREAKDOWN_SUCCESS:
            return {
                ...state,
                closingDateBreakdown: { data: action.payload, loading: false, loaded: true, error: null },
            };
        case GET_CLOSING_DATE_BREAKDOWN_FAILURE:
            return {
                ...state,
                closingDateBreakdown: { ...state.closingDateBreakdown, loading: false, loaded: false, error: action.payload },
            };

        case GET_LOANS_SUMMARY:
            return {
                ...state,
                loansSummary: { ...state.loansSummary, loading: true, error: null },
            };
        case GET_LOANS_SUMMARY_SUCCESS:
            return {
                ...state,
                loansSummary: { data: action.payload, loading: false, loaded: true, error: null },
            };
        case GET_LOANS_SUMMARY_FAILURE:
            return {
                ...state,
                loansSummary: { ...state.loansSummary, loading: false, loaded: false, error: action.payload },
            };
        case GET_CASHFLOW_PER_MONTH_BREAKDOWN:
            return {
                ...state,
                cashflowPerMonthBreakdown: { ...state.loansSummary, loading: true, error: null },
            };
        case GET_CASHFLOW_PER_MONTH_BREAKDOWN_SUCCESS:
            return {
                ...state,
                cashflowPerMonthBreakdown: { data: action.payload, loading: false, loaded: true, error: null },
            };
        case GET_CASHFLOW_PER_MONTH_BREAKDOWN_FAILURE:
            return {
                ...state,
                cashflowPerMonthBreakdown: { ...state.loansSummary, loading: false, loaded: false, error: action.payload },
            };
        case GET_DASHBOARD_SUMMARY_TOTALS:
            return {
                ...state,
                dashboardSummaryTotals: { ...state.dashboardSummaryTotals, loading: true, error: null },
            };
        case GET_DASHBOARD_SUMMARY_TOTALS_SUCCESS:
            return {
                ...state,
                dashboardSummaryTotals: { data: action.payload, loading: false, loaded: true, error: null },
            };
        case GET_DASHBOARD_SUMMARY_TOTALS_FAILURE:
            return {
                ...state,
                dashboardSummaryTotals: { ...state.dashboardSummaryTotals, loading: false, loaded: false, error: action.payload },
            };
        default:
            return state;
    }
};
export default reports;